import { createContext } from 'react';

const SharedDataContext = createContext();

export default SharedDataContext;
